import React from 'react';
import { IN_STOCK } from 'components/common/Routes';

class Home extends React.PureComponent {
  render() {
    return (
      <div>
        Home so{' '}
        <button onClick={() => this.props.history.push(`${IN_STOCK}/settings`)}>
          Go to settings
        </button>
      </div>
    );
  }
}

export default Home;
